export default __webpack_public_path__ + "static/media/rye.02788add.jpg";